import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { RootState, Dispatcher } from 'AppTypes'
import { LoadingSpinner } from '@share/components'
import MenuList from './partials/MenuList'
import MenuEditor from './MenuEditor'
import { fetchMenuTypes, fetchMenuProfile, changeMenuTab } from './state_management/actions'

import './MenuManagement.css'

const mapStateToProps = (state: RootState) => ({
  activeTab: state.menu.activeTab,
  isLoading: state.menu.isLoading
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  tabTitleClick: (tabId: number) => dispatch(changeMenuTab(tabId)),
  doFetchMenuProfile: () => dispatch(fetchMenuProfile()),
  doFetchMenuTypes: () => dispatch(fetchMenuTypes(''))
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

const MenuPage: React.FC<Props> = ({
  activeTab,
  isLoading,
  tabTitleClick,
  doFetchMenuProfile,
  doFetchMenuTypes
}) => {
  // didMounted
  useEffect(() => {
    doFetchMenuTypes()
    doFetchMenuProfile()
  }, [])

  // did updated
  useEffect(() => {
    if (activeTab === 1) {
      doFetchMenuProfile()
    }
  }, [activeTab])

  const { t } = useTranslation()

  return (
    <div className="main-content p-0">
      <LoadingSpinner isShowing={isLoading} />
      <ul
        className="nav nav-tabs"
        id="StoreInformationTab"
        role="tablist"
      >
        <li className="nav-item">
          <a
            className={activeTab === 1 ? 'nav-link active' : 'nav-link'}
            id="StoreInformation-BasicInformation-tab"
            data-toggle="tab"
            href="#StoreInformation-BasicInformation"
            role="tab"
            aria-controls="BasicInformation"
            aria-selected="true"
            onClick={() => tabTitleClick(1)}
          >
            {t('menuPage.menuListTabLabel')}
          </a>
        </li>
        <li className="nav-item">
          <a
            className={activeTab === 2 ? 'nav-link active' : 'nav-link'}
            id="StoreInformation-PriceRangeCategory-tab"
            data-toggle="tab"
            href="#StoreInformation-PriceRangeCategory"
            role="tab"
            aria-controls="PriceRangeCategory"
            aria-selected="false"
            onClick={() => tabTitleClick(2)}
          >
            {t('menuPage.menuEditTabLabel')}
          </a>
        </li>
      </ul>
      <div className="tab-content" id="StoreInformationTabContent">
        <div className={activeTab === 1 ? 'tab-pane fade show active' : 'tab-pane fade'} id="StoreInformation-BasicInformation" role="tabpanel" aria-labelledby="StoreInformation-BasicInformation-tab">
          <MenuList />
        </div>
        <div className={activeTab === 2 ? 'tab-pane fade show active' : 'tab-pane fade'} id="StoreInformation-PriceRangeCategory" role="tabpanel" aria-labelledby="StoreInformation-PriceRangeCategory-tab">
          <MenuEditor />
        </div>
      </div>
    </div>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MenuPage)
